/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_contact_fields_order_cancellation_type = /** @type {(inputs: {}) => string} */ () => {
	return `Zrušit nebo vrátit objednávku?`
};

const da_contact_fields_order_cancellation_type = /** @type {(inputs: {}) => string} */ () => {
	return `Annuller eller returnér ordren?`
};

const de_contact_fields_order_cancellation_type = /** @type {(inputs: {}) => string} */ () => {
	return `Bestellung stornieren oder zurückgeben?`
};

const en_contact_fields_order_cancellation_type = /** @type {(inputs: {}) => string} */ () => {
	return `Cancel or return the order?`
};

const es_contact_fields_order_cancellation_type = /** @type {(inputs: {}) => string} */ () => {
	return `¿Cancelar o devolver el pedido?`
};

const fr_contact_fields_order_cancellation_type = /** @type {(inputs: {}) => string} */ () => {
	return `Annuler ou retourner la commande ?`
};

const hu_contact_fields_order_cancellation_type = /** @type {(inputs: {}) => string} */ () => {
	return `Lemondott vagy visszaküldött rendelés?`
};

const it_contact_fields_order_cancellation_type = /** @type {(inputs: {}) => string} */ () => {
	return `Annullare o restituire l'ordine?`
};

const nl_contact_fields_order_cancellation_type = /** @type {(inputs: {}) => string} */ () => {
	return `Bestelling annuleren of retourneren?`
};

const pl_contact_fields_order_cancellation_type = /** @type {(inputs: {}) => string} */ () => {
	return `Anulować czy zwrócić zamówienie?`
};

const pt_contact_fields_order_cancellation_type = /** @type {(inputs: {}) => string} */ () => {
	return `Cancelar ou devolver o pedido?`
};

const sv_contact_fields_order_cancellation_type = /** @type {(inputs: {}) => string} */ () => {
	return `Avbryt eller returnera beställning?`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contact_fields_order_cancellation_type = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_fields_order_cancellation_type(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_fields_order_cancellation_type", locale)
	if (locale === "cs") return cs_contact_fields_order_cancellation_type(inputs)
	if (locale === "da") return da_contact_fields_order_cancellation_type(inputs)
	if (locale === "de") return de_contact_fields_order_cancellation_type(inputs)
	if (locale === "en") return en_contact_fields_order_cancellation_type(inputs)
	if (locale === "es") return es_contact_fields_order_cancellation_type(inputs)
	if (locale === "fr") return fr_contact_fields_order_cancellation_type(inputs)
	if (locale === "hu") return hu_contact_fields_order_cancellation_type(inputs)
	if (locale === "it") return it_contact_fields_order_cancellation_type(inputs)
	if (locale === "nl") return nl_contact_fields_order_cancellation_type(inputs)
	if (locale === "pl") return pl_contact_fields_order_cancellation_type(inputs)
	if (locale === "pt") return pt_contact_fields_order_cancellation_type(inputs)
	return sv_contact_fields_order_cancellation_type(inputs)
};
export { contact_fields_order_cancellation_type as "contact.fields.order_cancellation_type" }